var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayArr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7498 11.2446C24.7498 11.6507 24.5885 12.0402 24.3013 12.3274C24.0142 12.6145 23.6247 12.7759 23.2186 12.7759H5.47749L12.0527 19.348C12.1951 19.4904 12.308 19.6594 12.385 19.8454C12.4621 20.0314 12.5017 20.2308 12.5017 20.4321C12.5017 20.6335 12.4621 20.8328 12.385 21.0188C12.308 21.2048 12.1951 21.3739 12.0527 21.5162C11.9103 21.6586 11.7413 21.7715 11.5553 21.8486C11.3693 21.9256 11.1699 21.9653 10.9686 21.9653C10.7672 21.9653 10.5678 21.9256 10.3818 21.8486C10.1958 21.7715 10.0268 21.6586 9.88443 21.5162L0.696932 12.3287C0.554332 12.1865 0.441195 12.0175 0.364 11.8315C0.286805 11.6455 0.24707 11.446 0.24707 11.2446C0.24707 11.0432 0.286805 10.8438 0.364 10.6577C0.441195 10.4717 0.554332 10.3027 0.696932 10.1605L9.88443 0.972985C10.172 0.685458 10.5619 0.523926 10.9686 0.523926C11.3752 0.523926 11.7652 0.685458 12.0527 0.972985C12.3402 1.26051 12.5017 1.65048 12.5017 2.05711C12.5017 2.46374 12.3402 2.85371 12.0527 3.14124L5.47749 9.71336H23.2186C23.6247 9.71336 24.0142 9.87469 24.3013 10.1619C24.5885 10.449 24.7498 10.8385 24.7498 11.2446Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayArr);
export default __webpack_public_path__ + "static/media/gray-arr.d818059a8c64e49fd7ae17827a5f25be.svg";
export { ForwardRef as ReactComponent };